import React, { useEffect, useState } from "react"
import clsx from "clsx"

import { getAvailablePaymentGateways } from "services"
import classes from "./PaymentGatewaySelector.module.scss"

const gateways = [
  {
    value: "haghighi_a2a",
    label: "بانکه حقیقی",
    logo: "/assets/images/banke-haghighi-logo.svg"
  },
  {
    value: "zarinpal",
    label: "زرین‌پال",
    logo: "/assets/images/zarinpal.jpg"
  }
]

const PaymentGatewaySelector = ({ value, onChange, disabled = false }) => {
  const [availableGateways, setAvailableGateways] = useState(null)

  useEffect(() => {
    let active = true

    const load = async () => {
      try {
        const response = await getAvailablePaymentGateways()

        if (!active) return

        setAvailableGateways(response)
      } catch (error) {
        if (!active) return

        setAvailableGateways(null)
      }
    }

    load()

    return () => {
      active = false
    }
  }, [])

  const visibleGateways =
    gateways.filter(gateway =>
      availableGateways?.[gateway.value] !== false
    )

  useEffect(() => {
    if (!visibleGateways.length) return
    if (visibleGateways.some(gateway => gateway.value === value)) return

    onChange(visibleGateways[0].value)
  }, [onChange, value, visibleGateways])

  if (!visibleGateways.length) return null

  return (
    <div className={classes["container"]}>
      <div className={classes["label"]}>روش پرداخت</div>
      <div className={classes["options"]}>
        {visibleGateways.map(gateway => (
          <button
            type="button"
            key={gateway.value}
            disabled={disabled}
            onClick={() => onChange(gateway.value)}
            className={clsx(
              classes["option"],
              value === gateway.value && classes["active"]
            )}
          >
            {gateway.logo && (
              <img
                className={classes["logo"]}
                src={gateway.logo}
                alt=""
                aria-hidden="true"
              />
            )}

            <span>{gateway.label}</span>
          </button>
        ))}
      </div>
    </div>
  )
}

export default PaymentGatewaySelector
